export default __webpack_public_path__ + "static/media/CIMB-Logo.58b5eb01.png";